import React, { useState } from 'react';
import {
    LayoutDashboard,
    LogOut,
    Menu,
    X
} from 'lucide-react';
import { useNavigate, Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import theme from '../config/theme';
// import routers
import routers from '../routers';
// import services
import { logout } from '../services/auth.service';
// import lib
import toastAlert from '../lib/toastAlert';

const Sidebar = () => {
    // hooks
    const dispatch = useDispatch();

    // state
    const [isOpen, setIsOpen] = useState(false);
    const [currentPage, setCurrentPage] = useState('');
    const navigate = useNavigate();

    const toggleSidebar = () => setIsOpen(!isOpen);

    const handleLogout = () => {
        logout(dispatch)
        toastAlert('success', 'Logout successfully!.', 'logout')
        navigate('/login');
    };

    return (
        <>
            <button
                onClick={toggleSidebar}
                className="lg:hidden fixed top-4 left-4 z-50 p-2 bg-cyan-600 text-white rounded-lg shadow-lg"
            >
                {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>

            <div
                style={{ background: `linear-gradient(to bottom, ${theme.colors.bg.tertiary}, ${theme.colors.bg.secondary})` }}
                className={`fixed lg:static inset-y-0 left-0 z-40 w-64 text-white transform transition-transform duration-300 ease-in-out ${isOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'
                    }`}
            >
                {/* Logo */}
                <Link to="/">
                    <div className="p-6 border-b border-cyan-500/20">
                        <h1 className="text-2xl font-bold">Gateway MLM</h1>
                        <p className="text-cyan-400 text-sm mt-1">Promoters Portal</p>
                    </div>
                </Link>

                {/* Menu Items */}
                <nav className="p-4 flex-1">
                    <ul className="space-y-2">
                        {
                            routers && routers.length > 0 && routers.map((item) => {
                                if (item.isSideLabel === true) {
                                    const Icon = item?.icon || LayoutDashboard;
                                    const isActive = currentPage === item.path;

                                    return (
                                        <li key={item.path}>
                                            <button
                                                onClick={() => {
                                                    setCurrentPage(item.path);
                                                    setIsOpen(false);
                                                    navigate(item.path)
                                                }}
                                                className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg transition-all ${isActive
                                                    ? 'bg-cyan-600 shadow-lg scale-105'
                                                    : 'hover:bg-cyan-600/50'
                                                    }`}
                                            >
                                                <Icon className="w-5 h-5" />
                                                <span className="font-medium">{item.name}</span>
                                            </button>
                                        </li>
                                    );
                                } return null;
                            })
                        }
                    </ul>
                </nav>

                {/* Logout Button */}
                <div className="p-4 border-t border-cyan-500/20">
                    <button
                        onClick={handleLogout}
                        className="w-full flex items-center gap-3 px-4 py-3 rounded-lg hover:bg-red-600/30 hover:border-red-600 border border-transparent transition-all text-red-400"
                    >
                        <LogOut className="w-5 h-5" />
                        <span className="font-medium">Logout</span>
                    </button>
                </div>
            </div>

            {isOpen && (
                <div
                    onClick={toggleSidebar}
                    className="lg:hidden fixed inset-0 bg-black bg-opacity-50 z-30"
                />
            )}
        </>
    );
};

export default Sidebar;